import React, { useState, useRef, useEffect } from "react";
import {
	Stage,
	Layer,
	Line as KonvaLine,
	Image as KonvaImage,
	Transformer,
} from "react-konva";
import { saveAs } from "file-saver";
import "./Canvas.css";

import AlertDialog from "./components/AlertDialog";
import store from "store2";
import Konva from "konva";
import { createClient } from "@supabase/supabase-js";
import OutlinedInput from "@mui/material/OutlinedInput";
import CloseIcon from "@mui/icons-material/Close";
import {
	Box,
	IconButton,
	Button,
	Toolbar,
	Checkbox,
	AppBar,
	MenuItem,
	Menu,
	Typography,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	TextField,
	Select,
	FormControl,
	InputLabel,
	FormLabel,
	RadioGroup,
	FormControlLabel,
	Radio,
	Card,
	CircularProgress,
	Backdrop,
} from "@mui/material";

import Popover from "@mui/material/Popover";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import SearchIcon from "@mui/icons-material/Search";
import UndoIcon from "@mui/icons-material/Undo";
import RedoIcon from "@mui/icons-material/Redo";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import ExportIcon from "@mui/icons-material/GetApp";
import GridOnIcon from "@mui/icons-material/GridOn";
import GridOffIcon from "@mui/icons-material/GridOff";
import RectangleIcon from "@mui/icons-material/Rectangle";
import CircleIcon from "@mui/icons-material/Circle";
import LineWeightIcon from "@mui/icons-material/LineWeight";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import FormatShapesIcon from "@mui/icons-material/FormatShapes";
import NatureIcon from "@mui/icons-material/Nature";
import BoltIcon from "@mui/icons-material/Bolt";
import SolarPowerIcon from "@mui/icons-material/SolarPower";
import SpeedIcon from "@mui/icons-material/Speed";
import PetsIcon from "@mui/icons-material/Pets";
import DirectionsWalkIcon from "@mui/icons-material/DirectionsWalk";
import CreateIcon from "@mui/icons-material/Create";
import PanToolIcon from "@mui/icons-material/PanTool";
import MenuIcon from "@mui/icons-material/Menu";
import ImageIcon from "@mui/icons-material/Image";
import PoolIcon from "@mui/icons-material/Pool";
import GateIcon from "@mui/icons-material/MeetingRoom";
import MapIcon from "@mui/icons-material/Map";
// Import images
import electricityImageSrc from "./images/electricity.png";
import solarPanelImageSrc from "./images/solar.svg";
import gasMeterImageSrc from "./images/gasMeter.svg";
import dogImageSrc from "./images/dog.svg";
import slideMotorImageSrc from "./images/slideMotor.svg";
import { Upload } from "@mui/icons-material";
import { decode } from "base64-arraybuffer";

import axios from "axios";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";

import CategoryIcon from "@mui/icons-material/Category";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FenceIcon from "@mui/icons-material/Fence";
import MoreVertSharpIcon from "@mui/icons-material/MoreVertSharp";

import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
// import Crop32SharpIcon from "@mui/icons-material/Crop32Sharp";
import Crop75SharpIcon from "@mui/icons-material/Crop75Sharp";
import { toast } from "react-toastify";
import { useMutateData } from "./services/api";
import SideBarActions from "./components/SideBarActions";
import TextDialogCompoent from "./components/TextDialogCompoent";
import DoubleGateShapte from "./components/DoubleGateShapte";
import SingleGate from "./components/SingleGate";
import ExistingFence from "./components/ExistingFence";
import Rectangle from "./components/Rectangle";
import Circle from "./components/Circle";
import Text from "./components/Text";
import Line from "./components/Line";
import Arrow from "./components/Arrow";
import CanvasGrid from "./components/CanvasGrid";
import TransformerComponent from "./components/TransformerComponent";
import treeImageSrc from "./images/tree.png";
import poolImageSrc from "./images/pool.jpg";
import ConcreteImageSrc from "./images/concrete.jpg";

const Canvas = () => {
	const [lines, setLines] = useState([]);
	const [vvv, setvvv] = useState(50);
	const [mainMenu, setMainMenu] = useState(false);
	const [isDrawing, setIsDrawing] = useState(false);
	const [showGrid, setShowGrid] = useState(true);
	// Defaulut shape selection is nothing.
	const [selectedShape, setSelectedShape] = useState("");
	const [shapes, setShapes] = useState([]);
	const [currentShape, setCurrentShape] = useState(null);
	const [history, setHistory] = useState([]);
	const [redoHistory, setRedoHistory] = useState([]);
	const [textInput, setTextInput] = useState("");
	const [searchInput, setSearchInput] = useState("");
	const [uploadedImage, setUploadedImage] = useState(null);
	const [scale, setScale] = useState({ x: 1, y: 1 });
	const [selectedId, setSelectedId] = useState(null);
	const [anchorEl, setAnchorEl] = useState(null);
	const [fenceAnchorEl, setFenceAnchorEl] = useState(null);
	const [gateAnchorEl, setGateAnchorEl] = useState(null);
	const [open, setOpen] = useState(false);
	const [mapDialogOpen, setMapDialogOpen] = useState(false);
	const [searchOpen, setSearchOpen] = useState(false);
	const [loginOpen, setLoginOpen] = useState(false);
	const [mapAddress, setMapAddress] = useState("");
	const [mapWidth, setMapWidth] = useState(400);
	const [mapHeight, setMapHeight] = useState(400);
	const [mapType, setMapType] = useState("roadmap");
	const [mapImage, setMapImage] = useState(null);
	const [images, setImages] = useState({});
	const [selectedType, setSelectedType] = useState(null); // Add this line

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [currentLocation, setCurrentLocation] = useState("");
	const [currentToken, setCurrentToken] = useState("");
	const [currentContact, setCurrentContact] = useState("");
	const [customfield_id, setCfid] = useState("");

	const [isInvalid, setIsInvalid] = useState("block");
	const [mode, setMode] = useState("");

	// function createData(
	// 	name,
	// 	calories,
	// 	fat,
	// 	carbs,
	// 	protein
	// ) {
	// 	return { name, calories, fat, carbs, protein };
	// }

	// ========================================== New state for managing circle shape.
	//
	// ===============================================================================

	const [dragging, setDragging] = useState(false);
	const [startPos, setStartPos] = useState({ x: 0, y: 0 });
	const [circle, setCircle] = useState(null);

	// ===============================================================================

	const filterOptions = createFilterOptions({
		// remove this line here
		limit: 5,

		stringify: (option) => JSON.stringify(option),
	});

	// const rows = [];
	const supabaseUrl = "https://qiwqbswgenqoyhpodedr.supabase.co";
	const supabaseKey =
		"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFpd3Fic3dnZW5xb3locG9kZWRyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjQ3NDEyMzksImV4cCI6MjA0MDMxNzIzOX0.9lwg87U2tXSlbNpQqVtrOnx0wA90mpFOP9eaoIVV-pI";
	const supabase = createClient(supabaseUrl, supabaseKey);

	useEffect(() => {
		if (window.localStorage.getItem("islogged")) {
			setCurrentContact(window.localStorage.getItem("currentContact"));
			setCurrentLocation(window.localStorage.getItem("currentLocation"));
			setCurrentToken(window.localStorage.getItem("currentToken"));
			setCfid(window.localStorage.getItem("currentCfid"));
		} else {
			setLoginOpen(true);
		}

		const loadImages = async () => {
			const electricityImage = new window.Image();
			const solarPanelImage = new window.Image();
			const gasMeterImage = new window.Image();
			const dogImage = new window.Image();
			const slideMotorImage = new window.Image();
			const poolImage = new window.Image();
			const concreteImage = new window.Image();
			const treeImage = new window.Image();
			treeImage.src = treeImageSrc;

			electricityImage.src = electricityImageSrc;
			solarPanelImage.src = solarPanelImageSrc;
			gasMeterImage.src = gasMeterImageSrc;
			dogImage.src = dogImageSrc;
			slideMotorImage.src = slideMotorImageSrc;
			poolImage.src = poolImageSrc;
			concreteImage.src = ConcreteImageSrc;

			await Promise.all([
				new Promise((resolve) => {
					electricityImage.onload = resolve;
				}),
				new Promise((resolve) => {
					solarPanelImage.onload = resolve;
				}),
				new Promise((resolve) => {
					gasMeterImage.onload = resolve;
				}),
				new Promise((resolve) => {
					dogImage.onload = resolve;
				}),
				new Promise((resolve) => {
					slideMotorImage.onload = resolve;
				}),
				new Promise((resolve) => {
					treeImage.onload = resolve;
				}),
				new Promise((resolve) => {
					poolImage.onload = resolve;
				}),
				new Promise((resolve) => {
					concreteImage.onload = resolve;
				}),
			]);

			setImages({
				electricity: electricityImage,
				solarPanel: solarPanelImage,
				gasMeter: gasMeterImage,
				dog: dogImage,
				slideMotor: slideMotorImage,
				tree: treeImage,
				pool: poolImage,
				concrete: concreteImage,
			});
		};

		loadImages();
	}, []);

	const shapeRefs = useRef([]);

	const handleWheel = (e) => {
		e.evt.preventDefault();
		const stage = e.target.getStage();
		const scaleBy = 1.1;
		const oldScale = stage.scaleX();

		const mousePointTo = {
			x: stage.getPointerPosition().x / oldScale - stage.x() / oldScale,
			y: stage.getPointerPosition().y / oldScale - stage.y() / oldScale,
		};

		const newScale = e.evt.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy;

		setScale({
			x: newScale,
			y: newScale,
		});

		stage.scale({ x: newScale, y: newScale });

		const newPos = {
			x: -(mousePointTo.x - stage.getPointerPosition().x / newScale) * newScale,
			y: -(mousePointTo.y - stage.getPointerPosition().y / newScale) * newScale,
		};
		stage.position(newPos);
		stage.batchDraw();
	};

	const handleMouseDown = (e) => {
		e.evt.stopPropagation();
		const stage = e.target.getStage();
		const pointerPosition = stage.getPointerPosition();
		const clickedOnEmpty = e.target === stage;

		// ========================= setting cicle states
		const pos_ = e.target.getStage().getPointerPosition();
		setStartPos(pos_);

		// ==============================================

		if (clickedOnEmpty) {
			setSelectedId(null);
			setSelectedType(null); // Add this line
		}

		const pos = {
			x: (pointerPosition.x - stage.x()) / stage.scaleX(),
			y: (pointerPosition.y - stage.y()) / stage.scaleY(),
		};

		if (selectedShape === "freedraw") {
			setIsDrawing(true);
			setLines([...lines, { id: Date.now(), points: [pos.x, pos.y] }]);
		} else if (selectedShape && selectedShape === "circle") {
			setDragging(true);
			// Applied circle position on mouse donw
			setIsDrawing(true);
			setCurrentShape({
				id: Date.now(),
				type: selectedShape,
				x: pos_.x,
				y: pos_.y,
				width: 0,
				height: 0,
				points: [pos_.x, pos_.y],
				text: "",
				image: uploadedImage,
			});
		} else if (selectedShape && selectedShape !== "hand") {
			setIsDrawing(true);
			setCurrentShape({
				id: Date.now(),
				type: selectedShape,
				x: pos.x,
				y: pos.y,
				width: 0,
				height: 0,
				points: [pos.x, pos.y],
				text: "",
				image: uploadedImage,
			});
		}
	};

	const handleMouseMove = (e) => {
		if (selectedId || !isDrawing) {
			return;
		}

		// =============================== break point
		var radius = 0;
		if (dragging) {
			const pos = e.target.getStage().getPointerPosition();
			radius = Math.sqrt(
				Math.pow(pos.x - startPos.x, 2) + Math.pow(pos.y - startPos.y, 2)
			);
			setCircle({
				x: startPos.x,
				y: startPos.y,
				radius: radius,
			});
		}

		// ==============================================

		const stage = e.target.getStage();
		const pointerPosition = stage.getPointerPosition();
		const point = {
			x: (pointerPosition.x - stage.x()) / stage.scaleX(),
			y: (pointerPosition.y - stage.y()) / stage.scaleY(),
		};

		if (selectedShape === "freedraw") {
			const lastLine = lines[lines.length - 1];
			lastLine.points = lastLine.points.concat([point.x, point.y]);
			lines.splice(lines.length - 1, 1, lastLine);
			setLines(lines.concat());
		} else {
			const newShape = { ...currentShape };

			switch (selectedShape) {
				case "rectangle":
					newShape.width = point.x - currentShape.x;
					newShape.height = point.y - currentShape.y;
					break;
				case "circle":
					newShape.width = point.x - currentShape.x;
					newShape.height = point.y - currentShape.y;
					newShape.radius = radius;
					break;
				case "doubleGate":
				case "singleGate":
					newShape.width = Math.abs(point.x - currentShape.x);
					newShape.height = Math.abs(point.y - currentShape.y);
					break;
				case "line":
				case "fence":
				case "tearOutFence":
				case "existingFence":
					newShape.points = [currentShape.x, currentShape.y, point.x, point.y];
					break;
				case "arrow":
					newShape.points = [currentShape.x, currentShape.y, point.x, point.y];
					break;
				case "text":
					newShape.width = point.x - currentShape.x;
					newShape.height = point.y - currentShape.y;
					newShape.text = textInput;
					break;
				case "electricity":
				case "solarPanel":
				case "gasMeter":
				case "dog":
				case "slideMotor":
				case "tree":
				case "pool":
				case "image":
				case "concrete":
					newShape.width = point.x - currentShape.x;
					newShape.height = point.y - currentShape.y;
					newShape.points = [currentShape.x, currentShape.y, point.x, point.y];
					break;
				case "map":
					newShape.image = mapImage;
					newShape.width = mapWidth;
					newShape.height = mapHeight;
					break;
				default:
					break;
			}

			setCurrentShape(newShape);
		}
	};

	const handleMouseUp = () => {
		// =====================================================
		setDragging(false);
		if (circle) {
			// Add the circle to the shapes list
			// setShapes([
			// 	...shapes,
			// 	{ x: circle.x, y: circle.y, radius: circle.radius, id: Date.now() },
			// ]);
		}

		// =========================================================

		if (isDrawing) {
			if (selectedShape === "freedraw") {
				setLines([...lines, currentShape]);
			}
			// else if (selectedShape === "circle") {
			// 	console.log(currentShape)
			// 	// setShapes([
			// 	// 	...shapes,
			// 	// 	{
			// 	// 		x: circle.x,
			// 	// 		y: circle.y,
			// 	// 		radius: circle.radius,
			// 	// 		id: circle.id,
			// 	// 	},
			// 	// ]);
			// }
			else {
				setShapes([...shapes, currentShape]);
			}
			setHistory([...history, { shapes: [...shapes], lines: [...lines] }]);
			setRedoHistory([]);
			setCurrentShape(null);
			setIsDrawing(false);
			setCircle(null);
		}
		// Modified selections
		// setSelectedShape("hand");
	};

	const toggleGrid = () => {
		setShowGrid(!showGrid);
	};
	const [isHandToolActive, setIsHandToolActive] = useState(false); // Hand tool state

	const selectShape = (shape) => {
		if (shape === "text") {
			setIsHandToolActive(false);
			setOpen(true);
		} else if (shape === "hand") {
			setSelectedShape(shape);
			setSelectedId(null);
			setIsHandToolActive(true);
		} else if (shape === "map") {
			setIsHandToolActive(false);
			setMapDialogOpen(true);
		} else {
			setIsHandToolActive(false);
			setSelectedShape(shape);
			setSelectedId(null);
		}
		handleClose();
	};

	//https://highlevel.stoplight.io/docs/integrations/791462a3367b9-get-custom-fields
	const handleLogin = async () => {
		const { data, error } = await supabase
			.from("users")
			.select("account_id, token,customfield_id")
			.match({ email: email, password: password });
		console.log(data);
		if (data.length > 0) {
			setCurrentToken(data[0].token);
			setCurrentLocation(data[0].account_id);
			setCfid(data[0].customfield_id);
			window.localStorage.setItem("islogged", "good");
			window.localStorage.setItem("currentToken", data[0].token);
			window.localStorage.setItem("currentLocation", data[0].account_id);
			window.localStorage.setItem("currentLocation", data[0].account_id);
			window.localStorage.setItem("currentCfid", data[0].customfield_id);
			setLoginOpen(false);
		} else {
			setIsInvalid("Invalid login");
		}
	};

	const handleTextSubmit = () => {
		setShapes([
			...shapes,
			{
				id: Date.now(),
				type: "text",
				x: 100,
				y: 100,
				width: 200,
				height: 30,
				text: textInput,
				fontSize: 20, // Ensure fontSize is set
				padding: 0, // Remove padding
			},
		]);
		setTextInput("");
		setOpen(false);
		// modified selections
		// setSelectedShape("hand");
	};

	const handleMapSubmit = () => {
		const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${mapAddress}&zoom=15&size=${mapWidth}x${mapHeight}&maptype=${mapType}&key=YOUR_API_KEY`;
		const img = new window.Image();
		img.src = mapUrl;
		img.onload = () => {
			setMapImage(img);
			setSelectedShape("map");
		};
		setMapDialogOpen(false);
	};

	const undo = () => {
		if (history.length > 0) {
			const newHistory = [...history];
			const lastState = newHistory.pop();
			console.log("Undo last state:", lastState);
			setRedoHistory([
				...redoHistory,
				{ shapes: [...shapes], lines: [...lines] },
			]);
			if (lastState) {
				setShapes(lastState.shapes || []);
				setLines(lastState.lines || []);
			}
			setHistory(newHistory);
		} else {
			console.log("Clearing canvas");
			// Clear the canvas if there is nothing in history
			setShapes([]);
			setLines([]);
			setRedoHistory([]);
		}
	};

	const redo = () => {
		if (redoHistory.length > 0) {
			const newRedoHistory = [...redoHistory];
			const nextState = newRedoHistory.pop();
			console.log("Redo next state:", nextState);
			setHistory([...history, { shapes: [...shapes], lines: [...lines] }]);
			if (nextState) {
				setShapes(nextState.shapes || []);
				setLines(nextState.lines || []);
			}
			setRedoHistory(newRedoHistory);
		}
	};

	const saveCanvas = () => {
		const json = JSON.stringify(shapes);
		localStorage.setItem("canvasShapes", json);
	};

	// ======================= ( exporting api hooks for draing ) =======================
	//
	//
	// ===================================================================================
	const [currentContactId, setCurrentContactId] = useState("");
	const [openSaveAlert, setOpenSaveAlert] = useState(false);
	const [confirmSave, setConfirmSave] = useState(false);
	const {
		mutate: exportCanvasData,
		isLoading: isTriggered,
		isSuccess: isSuccessExport,
		isErrorExport,
	} = useMutateData({
		onSuccess: (data) => {
			toast.success("Drawing saved successfully.");
		},
		onError: (error) => {
			toast.error("Drawing could not saved.");
			// console.log("Error details:", error);
		},
		debounceDelay: 1000, // Customize the debounce delay (in ms)
	});
	const exportCanvas = async () => {
		if (!currentContactId) {
			toast.warning("Please select a contact!");
			return;
		}
		setMainMenu(false);

		if (shapeRefs.current.length === 0) {
			toast.error("You do not have drawings to save!");
			return;
		}

		setOpenSaveAlert(false);
		setSearchOpen(false);
		const stage = shapeRefs.current[0].getStage();
		const transformers = stage.find("Transformer");

		// Hide all transformers
		transformers.forEach((transformer) => transformer.hide());
		stage.draw();

		// Set background color
		const backgroundLayer = new Konva.Layer();
		const rect = new Konva.Rect({
			x: 0,
			y: 0,
			width: stage.width(),
			height: stage.height(),
			fill: "white",
		});
		backgroundLayer.add(rect);
		stage.add(backgroundLayer);
		backgroundLayer.moveToBottom();
		stage.draw();

		const dataURL = stage.toDataURL({ pixelRatio: 3 });
		

		const base64 = dataURL.split("base64,")[1];

		// const { data, error } = await supabase.storage
		// 	.from("dev")
		// 	.upload("public/" + currentContact + ".png", decode(base64), {
		// 		contentType: "image/png",
		// 	});

		// if (error) {
		// 	const { data, error } = await supabase.storage
		// 		.from("dev")
		// 		.update("public/" + currentContact + ".png", decode(base64), {
		// 			contentType: "image/png",
		// 		});
		// }

		// update(
		// 	"https://qiwqbswgenqoyhpodedr.supabase.co/storage/v1/object/public/dev/public/" +
		// 		currentContact +
		// 		".png"
		// );

		// setTimeout(async function () {
		// 	const { data1 } = supabase.storage
		// 		.from("dev")
		// 		.getPublicUrl("public/avatar1.png", {
		// 			download: true,
		// 		});

		// 	console.log(data1);
		// }, 5000);

		// Remove background layer
		backgroundLayer.destroy();
		transformers.forEach((transformer) => transformer.show());
		stage.draw();
	
		if (!store.session("_sso_session")) {
			return;
		}
		const data = {
			ssoToken: store.session("_sso_session"),
			contactId: currentContactId,
			canvasImage: dataURL,
		};
		try {
			exportCanvasData({ endPoint: "/upload-contact-image", data: data });
			toast.info("Saving drawing.");
		} catch (error) {
			console.log(error);
		}
		// saveAs(dataURL, "canvas.jpg");
	};

	const update = async (url) => {
		const options = {
			method: "PUT",
			url: "https://services.leadconnectorhq.com/contacts/" + currentContact,
			headers: {
				Authorization: "Bearer " + currentToken,
				Version: "2021-07-28",
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			data: {
				customFields: [{ id: customfield_id, field_value: url }],
			},
		};

		try {
			const { data } = await axios.request(options);
			console.log(data);
		} catch (error) {
			console.error(error);
		}
	};
	const handleImageUpload = (e) => {
		const reader = new FileReader();
		reader.onload = () => {
			const img = new window.Image();
			img.src = reader.result;
			img.onload = () => {
				setUploadedImage(img);
				setShapes([
					...shapes,
					{
						id: Date.now(),
						type: "image",
						x: 100,
						y: 100,
						width: img.width,
						height: img.height,
						image: img,
					},
				]);
				// Modified selections
				// setSelectedShape("hand");
			};
		};
		reader.readAsDataURL(e.target.files[0]);
	};

	const deleteSelectedShape = () => {
		if (selectedId) {
			const newShapes = shapes.filter((shape) => shape.id !== selectedId);
			setShapes(newShapes);

			const newLines = lines.filter((line) => line.id !== selectedId);
			setLines(newLines);

			setSelectedId(null);
		}
	};

	const handleMenuClick = (event) => {
		setMainMenu(true);
		setAnchorEl(event.currentTarget);
	};

	const handleFenceMenuClick = (event) => {
		setFenceAnchorEl(event.currentTarget);
	};

	const handleGateMenuClick = (event) => {
		setGateAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
		setMainMenu(false);
		setFenceAnchorEl(null);
		setGateAnchorEl(null);
	};

	const [dblClicked, setDblClicked] = useState(false);

	const renderShape = (shape, index) => {
		if (!shape) {
			console.error("Shape is undefined at index:", index);
			return null;
		}
		var is_draggable = shape.id && isHandToolActive;
		const shapeProps = {
			onClick: () => {
				if (isHandToolActive) {
					setSelectedId(shape.id);
				} else if (shape.id !== selectedId && dblClicked) {
					setSelectedId(shape.id);
					setIsHandToolActive(true);
					setDblClicked(false);
				}
				setSelectedType("shape"); // Add this line
			},
			onTap: () => {
				

				setSelectedId(shape.id);
				setSelectedType("shape"); // Add this line
			},
			onMouseDown: (e) => {
				if (isHandToolActive) {
					setSelectedId(shape.id);
					setSelectedType("shape");
					setDblClicked(false);
					setIsHandToolActive(true);
				}
			},
			// ondblclick: (e) => {
			// 	if (isHandToolActive) {
			// 		setSelectedId(shape.id);
			// 		setSelectedType("shape");
			// 		setDblClicked(true);
			// 		setIsHandToolActive(false);
			// 	}
			// },
			onDragEnd: (e) => {
				const newShapes = shapes.slice();
				newShapes[index] = {
					...shape,
					x: e.target.x(),
					y: e.target.y(),
				};
				setShapes(newShapes);
			},
			onTransformEnd: (e) => {
				const node = shapeRefs.current[index];
				const newShapes = shapes.slice();
				newShapes[index] = {
					...shape,
					x: node.x(),
					y: node.y(),
					rotation: node.rotation(),
					width: Math.max(5, node.width() * node.scaleX()), // Ensure minimum width
					height: Math.max(5, node.height() * node.scaleY()), // Ensure minimum height
				};

				if (shape.type === "circle") {
					// const radius =
					// 	Math.max(newShapes[index].width, newShapes[index].height) / 2;
					// newShapes[index].width = newShapes[index].width;
					// newShapes[index].height = newShapes[index].height;
					newShapes[index].radius =
						Math.max(newShapes[index].width, newShapes[index].height) / 2;
				}

				if (shape.type === "text") {
					newShapes[index].width = node.width();
					newShapes[index].height = node.height();
				}

				if (
					["line", "arrow", "fence", "tearOutFence", "existingFence"].includes(
						shape.type
					)
				) {
					const points = node.points();
					newShapes[index].points = points.map(
						(point, idx) =>
							point * (idx % 2 === 0 ? node.scaleX() : node.scaleY())
					);
					node.scaleX(1);
					node.scaleY(1);
				}

				if (shape.type === "text") {
					const scaleX = node.scaleX();
					const scaleY = node.scaleY();

					newShapes[index].width = Math.max(5, node.width() * scaleX);
					newShapes[index].height = Math.max(5, node.height() * scaleY);
					newShapes[index].fontSize = shape.fontSize * node.scaleX();
				}
				node.scaleX(1);
				node.scaleY(1);
				setShapes(newShapes);
			},

			ref: (node) => {
				shapeRefs.current[index] = node;
			},
			name: `shape-${shape.id}`,
			draggable: is_draggable,
		};

		switch (shape.type) {
			case "rectangle":
				return <Rectangle shape={shape} shapeProps={shapeProps} />;
			case "circle":
				return <Circle shape={shape} shapeProps={shapeProps} />;

			case "line":
				return <Line shape={shape} shapeProps={shapeProps} />;
			case "arrow":
				return <Arrow shape={shape} shapeProps={shapeProps} />;
			case "text":
				return <Text shape={shape} shapeProps={shapeProps} />;

			case "tree":
				return (
					<KonvaImage
						key={shape.id}
						{...shapeProps}
						image={images["tree"] || shape.image}
						x={shape.x}
						y={shape.y}
						width={shape.width}
						height={shape.height}
					/>
				);

			case "fence":
			case "tearOutFence":
			case "existingFence":
				return <ExistingFence shape={shape} shapeProps={shapeProps} />;
			case "singleGate":
				return <SingleGate shape={shape} shapeProps={shapeProps} />;
			case "doubleGate":
				return <DoubleGateShapte shape={shape} shapeProps={shapeProps} />;
			case "electricity":
			case "solarPanel":
			case "gasMeter":
			case "dog":
			case "slideMotor":
			case "image":
			case "pool":
			case "map":
			case "concrete":
				return (
					<KonvaImage
						key={shape.id}
						{...shapeProps}
						image={images[shape.type] || shape.image}
						x={shape.x}
						y={shape.y}
						width={shape.width}
						height={shape.height}
					/>
				);
			default:
				return null;
		}
	};

	const ref = useRef(null);
	const ref1 = useRef(null);
	const [artists, setArtists] = useState([]);

	const selectItem = (event) => {
		alert(event);
	};

	/*  ============================================================
	
	search contact modified code 
	
	================================================================ */
	const [searchKey, setSearchKey] = useState("email");
	const [optionData, setOptionData] = useState([]);
	const { mutate, isLoading, isSuccess, isError } = useMutateData({
		onSuccess: (data) => {
			try {
				const formattedData = data.contacts.map((item) => {
					return {
						id: item.id,
						firstNameLowerCase: item.firstNameLowerCase,
						lastNameLowerCase: item.lastNameLowerCase,
						phone: item.phone,
						email: item.email,
					};
				});
				setOptionData(formattedData);
			} catch (error) {
				setOptionData([]);
			}
		},
		onError: (error) => {
			console.log("Error details:", error);
		},
		debounceDelay: 1000, // Customize the debounce delay (in ms)
	});

	const searchNow = async (event) => {
		var operator = "contains";
		if (searchKey === "email") operator = "eq";
		if (!store.session("_sso_session")) {
			return;
		}
		const payload = {
			ssoToken:store.session("_sso_session"),
			field: searchKey,
			operator: operator,
			value: event,
		};
		try {
			mutate({ endPoint: "/search-contact", data: payload });
		} catch (error) {
			console.log(error);
		}

		// const url = "https://services.leadconnectorhq.com/contacts/";
		// const token = `Bearer ${currentToken}`;
		// const params = {
		// 	locationId: currentLocation,
		// 	startAfter: "0",
		// 	query: searchInput,
		// 	limit: "5",
		// };
		// const headers = {
		// 	Authorization: token,
		// 	Version: "2021-07-28",
		// 	Accept: "application/json",
		// };

		// setArtists([]);
		// setSearchInput(event);
		// const options = {
		// 	method: "GET",
		// 	url: url,
		// 	params: params,
		// 	headers: headers,
		// };

		// try {
		// 	const { data } = await axios.request(options);

		// 	if (data.contacts.length > 0) {
		// 		let asd = data.contacts.length * 35;
		// 		setvvv(100 + asd);
		// 	}

		// 	let tmp1 = [];

		// 	for (var i = 0; i < data.contacts.length; i++) {
		// 		let fn = "";
		// 		let ln = "";
		// 		if (data.contacts[i].firstName != null) {
		// 			fn = data.contacts[i].firstName;
		// 		}

		// 		if (data.contacts[i].lastName != null) {
		// 			ln = data.contacts[i].lastName;
		// 		}

		// 		let tmp = {
		// 			id: data.contacts[i].id,
		// 			label: fn + " " + ln,
		// 			phone: searchInput,
		// 			email: data.contacts[i].email,
		// 		};
		// 		tmp1.push(tmp);
		// 	}

		// 	setArtists((artists) => artists.concat([...tmp1]));
		// } catch (error) {
		// 	console.error(error);
		// }

		// setAnchorEl1(anchorEl2);
		//setMode("none");
	};

	// ================================================================

	// ================== Pin point Part 1.2
	// const handleClick1 = React.useCallback(() => ref.current?.click(), []);

	const setSearchOpen1 = () => {
		setSearchOpen(true);
		setMode("block");
		handleClose();

		//================= Pin point Part 1.1
		// Code Commented. Search Contact function

		// setTimeout(function () {
		// 	//
		// 	handleClick1();
		// }, 500);
	};

	const handleOnChange = (event, value, reason) => {
		setCurrentContact(
			value?.email ||
				value?.phone ||
				value?.firstNameLowerCase + " " + value?.lastNameLowerCase
		);
		setCurrentContactId(value?.id);
		// setSearchOpen(false);
	};

	const [anchorEl1, setAnchorEl1] = useState(null);
	const [anchorEl2, setAnchorEl2] = useState(null);

	const open1 = Boolean(anchorEl1);
	const handleClick = (event) => {
		setAnchorEl2(event.currentTarget);
		setAnchorEl1(event.currentTarget);
	};

	// ================= Pin point Part 1.3
	// const handleClick2 = (event) => {
	// 	handleClick1();
	// 	//setMode("none");
	// 	setAnchorEl1(anchorEl2);
	// };

	const handleClose1 = () => {
		setMode("block");
		setAnchorEl1(null);
	};

	return (
		<>
			<Backdrop
				sx={{
					color: "#fff",
					zIndex: (theme) => theme.zIndex.drawer + 1,
				}}
				open={isTriggered}
			>
				<CircularProgress color="inherit" />
			</Backdrop>
			<AppBar position="static" style={{ background: "white", color: "black" }}>
				<Toolbar>
					<Typography variant="h6" style={{ flexGrow: 1 }}>
						Fence Draw
					</Typography>
					<Box display="flex" alignItems="center">
						<Box>
							<IconButton
								onClick={toggleGrid}
								style={{ color: "gray", fontSize: "30px", margin: "0 10px" }}
							>
								{showGrid ? <GridOffIcon /> : <GridOnIcon />}
							</IconButton>

							<Typography
								align="center"
								style={{ fontSize: "12px", color: "gray" }}
							>
								Grid
							</Typography>
						</Box>

						<Box
							bgcolor={selectedShape === "hand" ? "#007bff" : "white"}
							color={selectedShape === "hand" ? "#fcfcfc" : "gray"}
							fontWeight={selectedShape === "hand" ? "bold" : "normal"}
						>
							<IconButton
								onClick={() => selectShape("hand")}
								style={{
									fontSize: "30px",
									margin: "0 10px",
									color: selectedShape === "hand" ? "white" : "gray",
								}}
							>
								<PanToolIcon />
							</IconButton>
							<Typography
								align="center"
								style={{
									fontSize: "12px",
								}}
							>
								Hand
							</Typography>
						</Box>

						<Box
							bgcolor={selectedShape === "rectangle" ? "#007bff" : "white"}
							color={selectedShape === "rectangle" ? "#fcfcfc" : "gray"}
							fontWeight={selectedShape === "rectangle" ? "bold" : "normal"}
						>
							<IconButton
								onClick={() => selectShape("rectangle")}
								style={{
									color: selectedShape === "rectangle" ? "#fcfcfc" : "gray",
									fontSize: "30px",
									margin: "0 10px",
								}}
							>
								{/* <RectangleIcon /> */}
								<Crop75SharpIcon />
							</IconButton>
							<Typography
								align="center"
								style={{
									fontSize: "12px",
								}}
							>
								Rectangle
							</Typography>
						</Box>

						<Box
							bgcolor={selectedShape === "circle" ? "#007bff" : "white"}
							color={selectedShape === "circle" ? "#fcfcfc" : "gray"}
							fontWeight={selectedShape === "circle" ? "bold" : "normal"}
						>
							<IconButton
								onClick={() => selectShape("circle")}
								style={{
									color: selectedShape === "circle" ? "#fcfcfc" : "gray",
									fontSize: "30px",
									margin: "0 10px",
								}}
							>
								{/* <CircleIcon /> */}
								<PanoramaFishEyeIcon />
							</IconButton>
							<Typography align="center" style={{ fontSize: "12px" }}>
								Circle
							</Typography>
						</Box>
						<Box
							bgcolor={selectedShape === "line" ? "#007bff" : "white"}
							color={selectedShape === "line" ? "#fcfcfc" : "gray"}
							fontWeight={selectedShape === "line" ? "bold" : "normal"}
						>
							<IconButton
								onClick={() => selectShape("line")}
								style={{
									color: selectedShape === "line" ? "#fcfcfc" : "gray",
									fontSize: "30px",
									margin: "0 10px",
								}}
							>
								<LineWeightIcon />
							</IconButton>
							<Typography align="center" style={{ fontSize: "12px" }}>
								Line
							</Typography>
						</Box>

						<Box
							bgcolor={selectedShape === "arrow" ? "#007bff" : "white"}
							color={selectedShape === "arrow" ? "#fcfcfc" : "gray"}
							fontWeight={selectedShape === "arrow" ? "bold" : "normal"}
						>
							<IconButton
								onClick={() => selectShape("arrow")}
								style={{
									color: selectedShape === "arrow" ? "#fcfcfc" : "gray",
									fontSize: "30px",
									margin: "0 10px",
								}}
							>
								<ArrowForwardIcon />
							</IconButton>
							<Typography align="center" style={{ fontSize: "12px" }}>
								Arrow
							</Typography>
						</Box>

						<Box
							bgcolor={selectedShape === "text" ? "#007bff" : "white"}
							color={selectedShape === "text" ? "#fcfcfc" : "gray"}
							fontWeight={selectedShape === "text" ? "bold" : "normal"}
						>
							<IconButton
								onClick={() => selectShape("text")}
								style={{
									color: selectedShape === "text" ? "#fcfcfc" : "gray",
									fontSize: "30px",
									margin: "0 10px",
								}}
							>
								<TextFieldsIcon />
							</IconButton>
							<Typography align="center" style={{ fontSize: "12px" }}>
								Text
							</Typography>
						</Box>

						<Box
							bgcolor={selectedShape === "concrete" ? "#007bff" : "white"}
							color={selectedShape === "concrete" ? "#fcfcfc" : "gray"}
							fontWeight={selectedShape === "concrete" ? "bold" : "normal"}
						>
							<IconButton
								onClick={() => selectShape("concrete")}
								style={{
									color: selectedShape === "concrete" ? "#fcfcfc" : "gray",
									fontSize: "30px",
									margin: "0 10px",
								}}
							>
								<FormatShapesIcon />
							</IconButton>
							<Typography align="center" style={{ fontSize: "12px" }}>
								Concrete
							</Typography>
						</Box>

						<Box
							bgcolor={
								selectedShape === "fence" ||
								selectedShape === "tearOutFence" ||
								selectedShape === "existingFence"
									? "#007bff"
									: "white"
							}
							color={
								selectedShape === "fence" ||
								selectedShape === "tearOutFence" ||
								selectedShape === "existingFence"
									? "#fcfcfc"
									: "gray"
							}
							fontWeight={
								selectedShape === "fence" ||
								selectedShape === "tearOutFence" ||
								selectedShape === "existingFence"
									? "bold"
									: "normal"
							}
						>
							<IconButton
								onClick={handleFenceMenuClick}
								style={{
									color:
										selectedShape === "fence" ||
										selectedShape === "tearOutFence" ||
										selectedShape === "existingFence"
											? "#fcfcfc"
											: "gray",
									fontSize: "30px",
									margin: "0 10px",
								}}
							>
								<FenceIcon />
							</IconButton>
							<Typography align="center" style={{ fontSize: "12px" }}>
								Fence
							</Typography>
							<Menu
								anchorEl={fenceAnchorEl}
								keepMounted
								open={Boolean(fenceAnchorEl)}
								onClose={handleClose}
							>
								<MenuItem onClick={() => selectShape("fence")}>Fence</MenuItem>
								<MenuItem onClick={() => selectShape("tearOutFence")}>
									Tear Out Fence
								</MenuItem>
								<MenuItem onClick={() => selectShape("existingFence")}>
									Existing Fence
								</MenuItem>
							</Menu>
						</Box>
						{/*  /////////////// ( Added labels to these ) /////////////////////////////// */}
						<Box>
							<IconButton
								onClick={handleGateMenuClick}
								style={{ color: "gray", fontSize: "30px", margin: "0 10px" }}
							>
								<GateIcon />
							</IconButton>
							<Typography
								align="center"
								style={{ fontSize: "12px", color: "gray" }}
							>
								Gates
							</Typography>
							<Menu
								anchorEl={gateAnchorEl}
								keepMounted
								open={Boolean(gateAnchorEl)}
								onClose={handleClose}
							>
								<MenuItem onClick={() => selectShape("singleGate")}>
									Single Gate
								</MenuItem>
								<MenuItem onClick={() => selectShape("doubleGate")}>
									Double Gate
								</MenuItem>
							</Menu>
						</Box>
						<Box>
							<IconButton
								onClick={handleMenuClick}
								style={{ color: "gray", fontSize: "30px", margin: "0 10px" }}
							>
								<MoreVertSharpIcon />
							</IconButton>
							<Typography
								align="center"
								style={{ fontSize: "12px", color: "gray" }}
							>
								Menu
							</Typography>
							<Menu
								anchorEl={anchorEl}
								keepMounted
								open={mainMenu}
								onClose={handleClose}
							>
								{/* <MenuItem onClick={}>
									<SearchIcon style={{ marginRight: "10px" }} /> Search Contact
								</MenuItem> */}

								<MenuItem onClick={() => setSearchOpen1()}>
									<ExportIcon style={{ marginRight: "10px" }} /> Save to Custom
									Field
								</MenuItem>

								<MenuItem onClick={() => selectShape("tree")}>
									<NatureIcon style={{ marginRight: "10px" }} /> Tree
								</MenuItem>

								<MenuItem onClick={() => selectShape("electricity")}>
									<BoltIcon style={{ marginRight: "10px" }} /> Electricity
								</MenuItem>
								<MenuItem onClick={() => selectShape("solarPanel")}>
									<SolarPowerIcon style={{ marginRight: "10px" }} /> Solar Panel
								</MenuItem>
								<MenuItem onClick={() => selectShape("gasMeter")}>
									<SpeedIcon style={{ marginRight: "10px" }} /> Gas Meter
								</MenuItem>
								<MenuItem onClick={() => selectShape("dog")}>
									<PetsIcon style={{ marginRight: "10px" }} /> Dog
								</MenuItem>
								<MenuItem onClick={() => selectShape("slideMotor")}>
									<DirectionsWalkIcon style={{ marginRight: "10px" }} /> Slide
									Motor
								</MenuItem>

								<MenuItem onClick={() => selectShape("pool")}>
									<PoolIcon style={{ marginRight: "10px" }} /> Pool
								</MenuItem>
							</Menu>
						</Box>

						<Box>
							<IconButton
								component="label"
								style={{ color: "gray", fontSize: "30px", margin: "0 10px" }}
							>
								<input type="file" hidden onChange={handleImageUpload} />
								<ExportIcon />
							</IconButton>
							<Typography
								align="center"
								style={{ fontSize: "12px", color: "gray" }}
							>
								Import
							</Typography>
						</Box>
						{/* <Box>
							<IconButton
								onClick={exportCanvas}
								style={{ color: "gray", fontSize: "30px", margin: "0 10px" }}
							>
								<Upload />
							</IconButton>

							<Typography
								align="center"
								style={{ fontSize: "12px", color: "gray" }}
							>
								Export
							</Typography>
						</Box> */}
					</Box>
				</Toolbar>
			</AppBar>

			{/* <Dialog
				style={{ overflow: "hidden", zIndex: 0 }}
				open={searchOpen}
				maxWidth="xs"
				fullWidth
				onClose={() => setSearchOpen(false)}
				PaperProps={{
					sx: {
						minHeight: "20%",
						height: 50,
						width: 350,
					},
				}}
			>
				<DialogTitle ref={ref} onClick={handleClick}>
					Search Contact
				</DialogTitle>
				<DialogContent style={{ overflow: "hidden" }}>
					<Typography sx={{ p: 2 }}>
						<TextField
							style={{ display: mode, position: "relative", left: -20 }}
							fullWidth
							onClick={handleClick2}
						/>
					</Typography>

					<Popover
						open={open1}
						anchorEl={anchorEl1}
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "left",
						}}
						onClose={handleClose1}
						PaperProps={{
							style: {
								backgroundColor: "transparent",
								boxShadow: "none",
							},
						}}
					>
						<Typography
							sx={{ p: 2, width: 300, height: vvv }}
							style={{ overflow: "hidden" }}
						>
							<Autocomplete
								disablePortal
								style={{ overflow: "hidden" }}
								options={artists}
								onChange={handleOnChange}
								getOptionLabel={(option) => option.label}
								filterOptions={filterOptions}
								renderInput={(params) => (
									<TextField
										ref={ref1}
										{...params}
										label=""
										onChange={(e) => searchNow(e.target.value)}
									/>
								)}
							/>{" "}
						</Typography>
					</Popover>
				</DialogContent>

				<DialogActions>

				</DialogActions>
			</Dialog> */}

			<Dialog
				open={searchOpen}
				fullWidth
				// onClose={() => setSearchOpen(false)}
				PaperProps={{
					sx: {
						width: "80%", // Increased dialog width
						minHeight: "70vh", // Increased minHeight for more space
						height: "70vh",
					},
				}}
			>
				<DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
					Search Contact
				</DialogTitle>

				{/* <IconButton
					aria-label="close"
					onClick={handleClose}
					sx={(theme) => ({
						position: "absolute",
						right: 8,
						top: 8,
						color: theme.palette.grey[500],
					})}
				>
					<CloseIcon />
				</IconButton>
				<DialogTitle
					ref={ref}
					sx={{
						fontSize: 22, // Increased font size for the title
						fontWeight: 600,
						color: "primary.main",
						cursor: "pointer",
						// borderBottom: "1px solid #ddd",
						p: 2,
					}}
					// display="flex"
					// justifyContent="space-between"
					onClick={handleClick}
					fullWidth={true}
				>
					Search Contact
				</DialogTitle> */}
				<Box
					sx={(theme) => ({
						position: "absolute",
						right: 8,
						top: 8,
						width: "20%",
						color: theme.palette.grey[500],
						display: "flex",
						justifyContent: "space-between",
					})}
				>
					<Button
						mr="60px"
						variant="outlined"
						color="primary"
						onClick={() => {
							if (!currentContactId) {
								toast.warning("Please select a contact!");
								return;
							} else setOpenSaveAlert(true);
						}}
					>
						Save
					</Button>
					<IconButton aria-label="close" onClick={() => setSearchOpen(false)}>
						<CloseIcon />
					</IconButton>
				</Box>
				<DialogContent style={{ padding: 10 }}>
					<FormControl>
						<FormLabel id="demo-controlled-radio-buttons-group">
							Search by
						</FormLabel>
						<RadioGroup
							aria-labelledby="demo-controlled-radio-buttons-group"
							name="controlled-radio-buttons-group"
							value={searchKey}
							onChange={(event) => setSearchKey(event.target.value)}
							row
						>
							<FormControlLabel
								value="firstNameLowerCase"
								control={<Radio size="small" />}
								label="First Name"
							/>
							<FormControlLabel
								value="lastNameLowerCase"
								control={<Radio size="small" />}
								label="Last Name"
							/>
							<FormControlLabel
								value="phone"
								control={<Radio size="small" />}
								label="Phone"
							/>
							<FormControlLabel
								value="email"
								control={<Radio size="small" />}
								label="Email"
							/>
						</RadioGroup>
					</FormControl>
					<Box mt={1}>
						<Autocomplete
							disablePortal
							options={optionData}
							onChange={handleOnChange}
							getOptionLabel={(option) =>
								(option.firstNameLowerCase || "") +
								" " +
								(option.lastNameLowerCase || "") +
								" " +
								(option.phone || "") +
								" " +
								(option.email || "")
							}
							loading={isLoading} // Show spinner when loading
							loadingText={<CircularProgress color="success" size="30px" />}
							renderInput={(params) => (
								<TextField
									ref={ref1}
									{...params}
									label=""
									sx={{
										"& .MuiOutlinedInput-root": {
											borderRadius: 1,
											borderColor: "#ddd",
											"&:hover": {
												borderColor: "primary.main",
											},
										},
									}}
									onChange={(e) => searchNow(e.target.value)}
								/>
							)}
							renderOption={(props, option) => {
								if (optionData.length === 0 && !isLoading) {
									return (
										<li {...props}>
											<Typography variant="body2" color="textSecondary">
												No contacts
											</Typography>
										</li>
									);
								}
								return (
									<li {...props}>
										{(option.firstNameLowerCase || "N/A") +
											" " +
											(option.lastNameLowerCase || "N/A") +
											" | " +
											(option.phone || "N/A") +
											" | " +
											(option.email || "N/A")}
									</li>
								);
							}}
						/>
					</Box>
				</DialogContent>
			</Dialog>
			{/*  Save Confirm ALert */}
			<AlertDialog
				open={openSaveAlert}
				setOpen={setOpenSaveAlert}
				onConfirm={exportCanvas}
			/>
			{/* ============================================= */}
			<TextDialogCompoent
				open={open}
				setOpen={setOpen}
				textInput={textInput}
				setTextInput={setTextInput}
				handleTextSubmit={handleTextSubmit}
			/>

			<Dialog open={mapDialogOpen} onClose={() => setMapDialogOpen(false)}>
				<DialogTitle>Address Lookup</DialogTitle>
				<DialogContent>
					<TextField
						margin="dense"
						label="Width"
						type="number"
						fullWidth
						value={mapWidth}
						onChange={(e) => setMapWidth(e.target.value)}
					/>
					<TextField
						margin="dense"
						label="Height"
						type="number"
						fullWidth
						value={mapHeight}
						onChange={(e) => setMapHeight(e.target.value)}
					/>
					<FormControl fullWidth margin="dense">
						<InputLabel>Map Type</InputLabel>
						<Select
							value={mapType}
							onChange={(e) => setMapType(e.target.value)}
						>
							<MenuItem value="roadmap">Roadmap</MenuItem>
							<MenuItem value="satellite">Satellite</MenuItem>
							<MenuItem value="hybrid">Hybrid</MenuItem>
							<MenuItem value="terrain">Terrain</MenuItem>
						</Select>
					</FormControl>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setMapDialogOpen(false)} color="primary">
						Cancel
					</Button>
					<Button onClick={handleMapSubmit} color="primary">
						Lookup
					</Button>
				</DialogActions>
			</Dialog>

			<SideBarActions
				undo={undo}
				redo={redo}
				deleteSelectedShape={deleteSelectedShape}
			/>
			<Stage
				draggable={selectedShape === "hand"}
				width={window.innerWidth}
				height={window.innerHeight}
				onWheel={handleWheel}
				onMouseDown={handleMouseDown}
				onMouseMove={handleMouseMove}
				onMouseUp={handleMouseUp}
				scaleX={scale.x}
				scaleY={scale.y}
				style={{ background: "white" }}
			>
				<Layer>
					{/* Grid Lines */}
					{showGrid && CanvasGrid()}

					{/* Draw Static Shapes */}
					{shapes.map((shape, i) => renderShape(shape, i))}

					{/* Draw Current Shape */}
					{currentShape && renderShape(currentShape, -1)}

					{history.length > 0 &&
						selectedId &&
						selectedType === "shape" &&
						!["tearOutFence", "existingFence", "fence"].includes(
							shapes.find((shape) => shape.id === selectedId).type
						) && (
							<TransformerComponent selectedShapeName={`shape-${selectedId}`} />
						)}

					{lines.map((line) => (
						<Line
							key={line?.id}
							id={line.id}
							points={line.points}
							stroke="red"
							strokeWidth={2}
							onClick={() => {
								setSelectedId(line.id);
								setSelectedType("line"); // Add this line
							}}
							isLine
							draggable={true}
						/>
					))}
				</Layer>
			</Stage>
		</>
	);
};

export default Canvas;
